import { Component, Input, OnInit } from '@angular/core';
import { AuctionsWalletItem, LottosWalletItem, MarketplaceWalletItem, RewardsWalletItem, WalletItemType } from '@fgb/core';

@Component({
  selector: 'fgbcl-rewards-wallet-redeem-list-item',
  templateUrl: './rewards-wallet-redeem-list-item.component.html',
  styleUrls: ['./rewards-wallet-redeem-list-item.component.scss'],
})
export class RewardsWalletRedeemListItemComponent implements OnInit {
  @Input() item: RewardsWalletItem;
  @Input() multi: boolean;
  @Input() showButton: boolean;
  @Input() orientation: 'landscape' | 'portrait' = 'portrait';
  marketplaceItem: MarketplaceWalletItem;
  lottoItem: LottosWalletItem;
  auctionItem: AuctionsWalletItem;
  itemType = WalletItemType;

  constructor() {
  }

  ngOnInit(): void {
    if (this.item?.ItemType == this.itemType.Marketplace) {
      this.marketplaceItem = this.item as MarketplaceWalletItem;
    } else if (this.item?.ItemType == this.itemType.Auction) {
      this.auctionItem = this.item as AuctionsWalletItem;
    } else if (this.item?.ItemType == this.itemType.Lotto) {
      this.lottoItem = this.item as LottosWalletItem;
    }
  }
}
